import { render, staticRenderFns } from "./MarqueeEvent.vue?vue&type=template&id=37b81866&scoped=true&"
import script from "./MarqueeEvent.vue?vue&type=script&lang=js&"
export * from "./MarqueeEvent.vue?vue&type=script&lang=js&"
import style0 from "./MarqueeEvent.vue?vue&type=style&index=0&id=37b81866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b81866",
  null
  
)

export default component.exports